import { ReactComponent as LogoutIcon } from "assets/icons/log_out.svg";
import { ReactComponent as ProfileIcon } from "assets/icons/UserIcon.svg";
import React, { useContext, useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { useHistory } from "react-router";
import { UserDataContext } from "store/UserContext";
import { toPersianNum } from "utils/helpers";
import Button from "../Button";
import "./style.scss";
import { useQuery } from "@tanstack/react-query";
import { getTotpQrCode } from "../../Services/Auth";

const Profile = React.memo(() => {
    const history = useHistory();
    const [userData, setToken] = useContext(UserDataContext);
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const { data, isSuccess } = useQuery(
        ["totp"],
        () => getTotpQrCode(),
        {
            cacheTime: 0,
        }
    )

    const handleLogout = () => {
        history.push("/");
        localStorage.removeItem("access_token");
        setToken(null);
    };

    const handleOpenNewTab = () => {
        window.open(data?.data.url,'Image','width=largeImage.stylewidth,height=largeImage.style.height,resizable=1');
    }

    return (
        <div className="profile-container text-left pushLeft">
            <ProfileIcon
                ref={target}
                onClick={() => setShow(!show)}
                className="cursor-pointer"
                data-testid="profile-icon"
            />
            <Overlay
                target={target.current}
                show={show}
                placement="bottom"
                rootClose={true}
                onHide={() => setShow(false)}
            >
                {(props) => (
                    <Popover id="popover" {...props}>
                        <Popover.Title as="h3">مشخصات کاربر</Popover.Title>
                        <Popover.Content>
                            <div
                                className="d-flex flex-row-reverse justify-content-between border border-light rounded p-4 mb-4">
                                <span>شماره تلفن همراه</span>
                                <strong>
                                    {toPersianNum(userData.phone, true)}
                                </strong>
                            </div>
                            { isSuccess ? (
                                <div
                                    className="d-flex flex-row-reverse justify-content-between border border-light rounded p-4 mb-4">
                                    <span dir="rtl">برای استفاده در Authenticator</span>
                                    <img src={data?.data.url} alt="totp" width="140px" height="140px" style={{ cursor: "pointer" }} onClick={handleOpenNewTab} />
                                </div>
                            ) : null }
                            <Button
                                btnText="خروج از حساب کاربری"
                                className="solid is-green pushLeft ml-0"
                                handleClick={handleLogout}
                            >
                                <LogoutIcon className="ml-2" />
                            </Button>
                        </Popover.Content>
                    </Popover>
                )}
            </Overlay>
        </div>
    );
});

export default Profile;
